import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import getContent from 'pp-react-l10n';
import { CDN_HOST_NAME } from '../../../utility/constants';
import { BodyText, CaptionText } from '@paypalcorp/pp-react-text';
import { V2CreditcardIcon } from '@paypalcorp/pp-react-icons';
import _isEmpty from 'lodash/isEmpty';
import { Badge } from '@paypalcorp/pp-react-badge';

const PaymentInformation = ({
  source,
  paymentDigits,
  paymentType,
  issuer,
  isPaypalCurrencyConversion,
  funds,
  cardType,
}) => {
  const crossBorderContent = getContent('locals')('guest/crossBorder');
  const paymentInformation = crossBorderContent(
    'label.paymentInformation',
    { type: paymentType, number: paymentDigits },
    { useHTML: true }
  );
  const preferred = crossBorderContent('label.preferred');
  const [paymentLogo, setPaymentLogo] = useState('');

  const transformText = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const getIssuer = () => {
    return issuer?.toLowerCase().split(' ').map(transformText).join(' ');
  };

  useEffect(() => {
    let cardImg = source?.payment_card?.issuer?.thumbnail_logo_url ?? null;
    if (
      cardImg === null ||
      _isEmpty(cardImg) ||
      typeof cardImg === 'undefined'
    ) {
      cardImg = `${CDN_HOST_NAME}/digitalassets/c/consumer/p2p/funding-sources/${cardType}.png`;
    }
    setPaymentLogo(cardImg);
  }, []);

  return (
    <div className="cb-payment-information ppvx_justify-content-between">
      <div className="payment-info">
        {!_isEmpty(paymentLogo) ? (
          <img src={paymentLogo} className="payment-logo" aria-hidden="true" />
        ) : (
          <V2CreditcardIcon size="xl2" />
        )}
        <div className="pay-info">
          {issuer && <BodyText>{getIssuer()}</BodyText>}
          <CaptionText className="funding-info">
            {paymentInformation}
          </CaptionText>
          {!isPaypalCurrencyConversion && (
            <Badge type="success">{preferred}</Badge>
          )}
        </div>
      </div>
      <BodyText>{funds}</BodyText>
    </div>
  );
};

PaymentInformation.propTypes = {
  fundingOptions: PropTypes.object,
  paymentDigits: PropTypes.number,
  paymentType: PropTypes.string,
  issuer: PropTypes.string,
  funds: PropTypes.string,
  isPaypalCurrencyConversion: PropTypes.string,
  source: PropTypes.object,
  cardType: PropTypes.string,
};

export default PaymentInformation;
